export default "__VITE_ASSET__q6idJ3h6__"